import * as React from "react";
import { useTryInStoreStorage } from "../../hooks/hooks/use-try-in-store-storage.js";
import { TryInStoreContext } from "./context.js";
const TryInStoreProvider = ({ children }) => {
  const storageValues = useTryInStoreStorage();
  return /* @__PURE__ */ React.createElement(TryInStoreContext.Provider, { value: storageValues }, children);
};
export {
  TryInStoreProvider
};
//# sourceMappingURL=provider.js.map
